export default "__VITE_ASSET__BaaGL5Ia__"